module.exports = __webpack_public_path__ + "img/badge-communication-key-silver.9dc33a26.svg";